<template>
	<vs-popup
		:title="$t('indicateThePrice')"
		class="primary-popup set-ticket-failed"
		:active.sync="activeProp"
	>
		<div v-if="stage !== null" class="prices__container">
			<div v-if="userRole === 'admin'" class="vx-col stage-list__item">
				<vs-input
					:label="$t('paymentAmount')"
					v-model="price_client"
				/>
			</div>
			<div class="vx-col stage-list__item" v-if="!completedStatus">
				<vs-input
					:label="$t('priceForJuniorAndMiddle')"
					v-model="price_junior_middle"
				/>
			</div>
			<div class="vx-col stage-list__item" v-if="!completedStatus">
				<vs-input
					:label="$t('priceForSenior')"
					v-model="price_senior"
				/>
			</div>
		</div>
		<div class="set-ticket-failed__controls">
			<vs-button
				:disabled="isDisabled"
				color="primary"
				@click="confirm"
			>{{ $t('save') }}</vs-button>

			<vs-custom-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('cancel') }}</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>

export default {
	name: "SetStageChangePopup",
	props: {
		active: 		{ default: false, type: Boolean },
		stage:  		{ default: () => ({}) },
	},
	data() {
		return {
			isDisabled: false,
			price_junior_middle: '',
			price_senior: '',
			price_client: '',
            updatedStage: null
		}
	},
	watch: {
        stage(val) {
            if (val) {
                this.price_client = val.price_client;
                this.price_junior_middle = val.price_junior_middle;
                this.price_senior = val.price_senior;
            }
        },
		activeProp(newValue) {
			if(newValue === false) {
				// this.stage = null;
				this.price_junior_middle = '';
				this.price_senior = '';
				this.price_client = '';
			}
		},
		price_junior_middle(val) {
			this.validate(val, this.price_senior, this.price_client)
		},
		price_senior(val) {
			this.validate(val, this.price_junior_middle, this.price_client)
		},
		price_client(val) {
            this.validate(this.price_senior, this.price_junior_middle, val)
		},
	},
	computed: {
        completedStatus() {
            if (this.stage.status) return this.stage.status === 'completed'
            return false
        },
        userRole() {
			return this.$store.state.auth.role;
		},
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				this.$emit("update:stage", null);
				return this.active;
			}
		}
	},

    mounted() {
        this.$nextTick(() => {
            if (this.stage && this.stage.id) {
                this.price_client = this.stage.price_client;
                this.price_junior_middle = this.stage.price_junior_middle;
                this.price_senior = this.stage.price_senior;
            }
        })
    },

	methods: {
		validate(price, price2, price3) {
            const regex = /^[\.\,0-9]*$/
			if (
                price === '' || isNaN(price) || !regex.test(price) ||
                price2 === '' || isNaN(price2) || !regex.test(price2) ||
                price3 === '' || isNaN(price3) || !regex.test(price3)) {
				this.isDisabled = true;
			} else {
				this.isDisabled = false;
			}

		},
		confirm() {
			if(this.stage === null) return;

			if (this.price_junior_middle === '' || this.price_senior === '') return;
			this.stage.price_client = +this.price_client
            if (!this.completedStatus) {
                this.stage.price_junior_middle = +this.price_junior_middle;
                this.stage.price_senior = +this.price_senior;
            }

			this.$emit("confirm", this.stage);
			this.activeProp = false;
		},
		close() {
			this.activeProp = false;
		}
	},
	
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-failed {
	&__title {
		padding-left: 8px;
		padding-right: 8px;
	}

	&__list {
		padding-left: 8px;
		padding-right: 8px;
		margin-top: 7px;
	}

	&__item {
		margin-top: 5px;
	}

	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 350px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
            overflow: hidden;
		}

		&--close,
		&--title h3 {
			color: $primary;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
		.prices__container {
			display: flex;
			flex-direction: column;
            .vs-con-input-label {
                width: 100%;
            }
		}
	}
}
</style>
